import { ThemeProps } from '../Theme/ThemeComponentTypes'

export const isDarkTheme = (theme?: ThemeProps['theme']) => theme?.themeName === 'dark'
